import { jsPDF } from "jspdf";
import "jspdf-autotable";
import DateTime from "../util/DateTime";

class ReportBaseService {

    async SetHeaderAndFooter(doc, param) {
        await this.SetHeader(doc, param);
        await this.SetFooter(doc, param);
    }

    async SetHeader(doc, param) {
        const tableData = [
            ['            ', 'RELATÓRIO DE AVALIAÇÃO FITOSSANITÁRIO', 'GAAU'],
            ['', 'GRAU DE ATENÇÃO PARA ÁRVORES URBANA', DateTime.FormatPtBr()],
        ];

        // Configurações da tabela
        const tableConfig = {
            startY: 10, // Posição vertical inicial da tabela no PDF
            styles: {
                cellPadding: 3,
                fontSize: 12,
                fillColor: [255, 255, 255], 
                textColor: [0, 0, 0], 
                lineWidth: 0.3,
                lineColor: 'black',
                halign: 'center'
            },
            alternateRowStyles: {
                fillColor: false,
            },
            allSectionHooks: true,
            didParseCell: function (data) {
                if (data.column.dataKey === 0 && data.column.index === 0) {
                    data.cell.rowSpan = 2;
                }
                if (data.row.index === 0 && data.column.index === 2) {
                    data.cell.styles.fillColor = [255, 255, 255];
                    data.cell.styles.lineWidth = {
                        top: 0.3,
                        right: 0.3,
                        bottom: 0,
                        left: 0.3
                    }
                }

                if (data.row.index === 1 && data.column.index === 2) {
                    data.cell.styles.lineWidth = {
                        top: 0,
                        right: 0.3,
                        bottom: 0.3,
                        left: 0.3
                    }
                }

            },

        };

        doc.autoTable({
            body: tableData,
            ...tableConfig,
        });
        doc.addImage(param.imageHeader, "PNG", 17, 11, 20, 20);
    }

    async SetFooter(doc, param) {
        const tableData = [
            ['            ', param.companyName,],
            ['', param.address],
            ['', param.phone + ' ' + param.email + ' ' + param.site],

        ];

        // Configurações da tabela
        const tableConfig = {
            startY: doc.internal.pageSize.height - 27, 
            styles: {
                cellPadding: 0.5,
                fontSize: 8,
                fillColor: [255, 255, 255],
                textColor: [0, 0, 0], 
            },
            alternateRowStyles: {
                fillColor: false, 
            },
            allSectionHooks: true,
            didParseCell: function (data) {
                if (data.column.dataKey === 0 && data.column.index === 0) {
                    data.cell.rowSpan = 3;
                }
            },
        };

        doc.autoTable({
            body: tableData,
            ...tableConfig,
        });
        doc.addImage(param.imageHeader, "PNG", 18, doc.internal.pageSize.height - 27, 12, 12);

    }

}

export default new ReportBaseService();
